var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalDetailPriority","title":'Configuración',"size":"lg","centered":"","text":"","ok-only":"","ok-title":"Buscar","ok-variant":"warning","hide-footer":""}},[_c('b-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }